import { useCurrentTenant } from "@qpr/client-library/dist/esm";
import useTopElement from "backend/hooks/model/useTopElement";
import HomeIcon from "design/components/icons/HomeIcon";
import { getTranslatedAttribute } from "qpr-base//tplutils/utils";
import useParents from "qpr-base/apihooks/useParents";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useCreateLink";
import BreadcrumbDesign from "qpr-base/ui/BreadcrumbDesign";
import Loader from "qpr-base/ui/components/Loader";
import React from "react";
import typeToView from "routing/typetoview";

const Breadcrumb = () => {
  const ctx = useAppContext();
  const tenant = useCurrentTenant();
  const { data: topElement, isLoading: topElementLoading } = useTopElement(
    "L0",
    "id,name,typename"
  );
  const parents = useParents(ctx.elementId || "");
  const link = useLink();
  const home = {
    url: `/${tenant.symbol}/${ctx.modelId}/landingpage/${ctx.modelId}`,
    icon: <HomeIcon />,
  };

  if (!topElement) return <></>;
  if (!parents || topElementLoading) {
    return <Loader />;
  }

  if (
    !parents ||
    !ctx.elementId ||
    parents.length === 0 ||
    ctx.page === "landingpage"
  ) {
    return (
      <BreadcrumbDesign
        items={[
          home,
          {
            title: getTranslatedAttribute(topElement, "Name", ctx.language),
            url: `/${tenant.symbol}/${ctx.modelId}/strategymap/${topElement.id}`,
          },
        ]}
      />
    );
  }

  return (
    <BreadcrumbDesign
      items={[
        home,
        ...parents
          .filter((p) => typeToView(p.typename))
          .map((p) => {
            return {
              title: getTranslatedAttribute(p, "Name", ctx.language),
              url: link({ meaId: p.id, page: typeToView(p.typename) }),
            };
          }),
      ]}
    />
  );
};

export default Breadcrumb;
